window.fileDrop = {
  init: function (dropZoneId, inputId) {
    try {
      console.log("[fileDrop] init", { dropZoneId, inputId });

      const zone = document.getElementById(dropZoneId);
      const input = document.getElementById(inputId);

      if (!zone) {
        console.error("[fileDrop] drop zone not found:", dropZoneId);
        return;
      }
      if (!input) {
        console.error("[fileDrop] input not found:", inputId);
        return;
      }

      const prevent = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };

      ["dragenter", "dragover", "dragleave", "drop"].forEach((evt) => {
        zone.addEventListener(evt, prevent);
      });

      zone.addEventListener("drop", (e) => {
        prevent(e);

        const files = e.dataTransfer && e.dataTransfer.files;
        const len = files ? files.length : 0;

        console.log("[fileDrop] drop", { count: len });

        if (!files || len === 0) return;

        const dt = new DataTransfer();
        for (let i = 0; i < len; i++) dt.items.add(files[i]);

        input.files = dt.files;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      console.log("[fileDrop] ready", { dropZoneId, inputId });
    } catch (err) {
      console.error("[fileDrop] init error", err);
    }
  },
};
